import { Component, QueryList, ContentChildren, AfterContentInit, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { DashTabComponent } from './dash-tab/dash-tab.component';

@Component({
    selector: 'aa-dash-tab-group',
    templateUrl: './dash-tab-group.component.html',
    styleUrls: [
        './dash-tab-group.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashTabGroupComponent implements OnInit, AfterContentInit
{
    @ContentChildren(DashTabComponent) tabs: QueryList<DashTabComponent>;
    @Input() justified: boolean = false;
    @Input() height: number = 38;
    @Input() customCls: string = '';
    @Output() selectedDashTab: EventEmitter<DashTabComponent> = new EventEmitter();
    private oldTabIndex: number = undefined;
    private newTabIndex: number = 0;
    public height1: number;

    constructor(
    ) { }

    ngOnInit ()
    {
        this.height1 = this.height;
    }

    ngAfterContentInit ()
    {
        this.tabs.forEach((tab, idx) => tab.id = idx);
    }

    onClickTab (tab: DashTabComponent): void
    {
        this.selectTab(tab);
    }

    selectTab (tab: DashTabComponent): void
    {
        this.activateTab(tab);
    }

    private activateTab (tab: DashTabComponent): void
    {
        this.oldTabIndex = this.newTabIndex;

        this.newTabIndex = tab.id;
        this.selectedDashTab.emit(tab);
        this.tabs.toArray().forEach((t) => t.active = false);
        tab.active = true;
    }
}
